import { render, staticRenderFns } from "./MovieSuggest.vue?vue&type=template&id=1c6f0e4b&scoped=true&"
import script from "./MovieSuggest.vue?vue&type=script&lang=js&"
export * from "./MovieSuggest.vue?vue&type=script&lang=js&"
import style0 from "./MovieSuggest.vue?vue&type=style&index=0&id=1c6f0e4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6f0e4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VListTileSubTitle } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VChip,VListTileContent,VListTileSubTitle,VListTileTitle})
